import { error } from "@sveltejs/kit";
import { p as prisma } from "../../../../../chunks/prisma.js";
const load = async ({ params }) => {
  const id = parseInt(params.id);
  if (isNaN(id)) {
    throw error(400, "Invalid legislation ID");
  }
  const legislation = await prisma.legislationItem.findUnique({
    where: { id }
  });
  if (!legislation) {
    throw error(404, "Legislation not found");
  }
  return {
    legislation
  };
};
export {
  load
};
